<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import {
		LinkedInIcon,
		FacebookIcon,
		InstagramIcon,
		YouTubeIcon,
		TikTokIcon
	} from "#lib/web-ui/primitives/index.js";
	import type { FooterContactColumnProps } from "./footer.types";

	let {
		logoUrl,
		logoAlt = "Company Logo",
		logoClass = "h-9",
		logoWidth,
		logoHeight,
		tagline,
		address,
		addressLink,
		socialLinks,
		class: className
	}: FooterContactColumnProps = $props();
</script>

<div class={cn("space-y-4", className)}>
	<img
		class={cn("w-auto", logoClass)}
		src={logoUrl}
		alt={logoAlt}
		width={logoWidth}
		height={logoHeight}
	/>

	{#if tagline}
		<p class="text-background/50 text-sm/6 text-balance">
			{tagline}
		</p>
	{/if}

	<a
		href={addressLink}
		target="_blank"
		rel="noopener noreferrer"
		class="text-background/50 hover:text-background block transition"
	>
		{address.street}<br />
		{#if address.suite}
			{address.suite}<br />
		{/if}
		{address.city}, {address.state}
		{address.zip}
	</a>

	<div class="flex gap-x-6">
		{#if socialLinks.facebook}
			<a
				href={socialLinks.facebook}
				target="_blank"
				rel="noopener noreferrer"
				class="text-background/50 hover:text-background transition"
			>
				<span class="sr-only">Facebook</span>
				<FacebookIcon />
			</a>
		{/if}
		{#if socialLinks.instagram}
			<a
				href={socialLinks.instagram}
				target="_blank"
				rel="noopener noreferrer"
				class="text-background/50 hover:text-background transition"
			>
				<span class="sr-only">Instagram</span>
				<InstagramIcon />
			</a>
		{/if}
		{#if socialLinks.linkedin}
			<a
				href={socialLinks.linkedin}
				target="_blank"
				rel="noopener noreferrer"
				class="text-background/50 hover:text-background transition"
			>
				<span class="sr-only">LinkedIn</span>
				<LinkedInIcon />
			</a>
		{/if}
		{#if socialLinks.youtube}
			<a
				href={socialLinks.youtube}
				target="_blank"
				rel="noopener noreferrer"
				class="text-background/50 hover:text-background transition"
			>
				<span class="sr-only">YouTube</span>
				<YouTubeIcon />
			</a>
		{/if}
		{#if socialLinks.tiktok}
			<a
				href={socialLinks.tiktok}
				target="_blank"
				rel="noopener noreferrer"
				class="text-background/50 hover:text-background transition"
			>
				<span class="sr-only">TikTok</span>
				<TikTokIcon />
			</a>
		{/if}
	</div>
</div>
